import { Stack, TableCell, TableRow } from '@atgfr8/atg-ui-tailwind';
import { Notification } from '@components/Notification';
import { Component, Show, mergeProps } from 'solid-js';

import classes from './classes';

export type TableErrorRowProps = {
  columnsLength: number;
  tableErrors: string[];
  tableRowClasses?: string;
  type?: 'tableError' | 'warning' | 'info';
  class?: string;
};

export const TableRowErrors: Component<TableErrorRowProps> = (
  props: TableErrorRowProps,
) => {
  const mp = mergeProps(
    {
      type: 'tableError',
    },
    props,
  );

  return (
    <Show when={props.tableErrors.length > 0}>
      <TableRow class={`${classes.tableRow} ${props.tableRowClasses}`}>
        <TableCell colSpan={props.columnsLength + 1} class={classes.errorRow}>
          <Notification
            type={mp.type}
            tableRowNotification
            getCustomStyle={() => props.class}
            text={
              <Stack spacing={0.5}>
                <ul class={classes.errorListContainer}>
                  {props.tableErrors.map((error) => (
                    <li class={classes.errorListLine}>{`${error}`}</li>
                  ))}
                </ul>
              </Stack>
            }
          />
        </TableCell>
      </TableRow>
    </Show>
  );
};
